import { render, staticRenderFns } from "./Taxcode.vue?vue&type=template&id=587e28f0"
import script from "./Taxcode.vue?vue&type=script&lang=js"
export * from "./Taxcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports